import {useEffect, useRef, useState} from 'react';

const DEFAULT_TIME = 60;

interface Props {
  initialTime?: number;
  enabled?: boolean;
  onFinish?: () => void;
}

const useTimer = ({initialTime = DEFAULT_TIME, enabled = true, onFinish}: Props) => {
  const limit = initialTime;
  const [count, setCount] = useState(limit);
  const timer = useRef<ReturnType<typeof setInterval>>();
  const onFinishRef = useRef(onFinish);
  onFinishRef.current = onFinish;

  useEffect(() => {
    if (enabled) {
      setCount(limit);
      timer.current = setInterval(() => setCount(c => c - 1), 1000);
    }
    return () => clearInterval(timer.current);
  }, [enabled, limit]);

  useEffect(() => {
    if (count <= 0) {
      clearInterval(timer.current);
      onFinishRef.current?.();
    }
  }, [count]);
  return {count};
};

export {useTimer};
